// extracted by mini-css-extract-plugin
export default {"wrap":"r5zm9O0nqUvxMCk8z2YL"};